// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, LoadProducts } from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

// Carousels (Recently Viewed, Cross Sells, etc.) never requested "variantTraits", so
// ProductCarouselProduct could never resolve a default item for variant-parent products
// the first time they're shown (PLP's DisplayProducts.ts already requests this token).
// Products previously viewed on PDP happened to work anyway because state.data.products.byId
// is a shared/merged store (assignById merges partial fetches), so a PDP visit's full expand
// leaks variantTraits into the same entity used later by the carousel - masking this gap.
export const AddVariantTraitsExpand: typeof LoadProducts = props => {
    if (!props.getProductCollectionParameter) {
        return;
    }
    if (props.getProductCollectionParameter.expand) {
        if (!props.getProductCollectionParameter.expand.includes("variantTraits")) {
            props.getProductCollectionParameter.expand.push("variantTraits");
        }
    } else {
        props.getProductCollectionParameter.expand = ["variantTraits"];
    }
};

addToChainBefore(chain, LoadProducts, AddVariantTraitsExpand);
